import React from 'react';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export const Locationaddress = () => {
    return (
        <div>
            <form className='sectionalForms'>
                <div className="row">
                <div className="col-lg-12 col-md-6 col-sm-12">
                    <div className="formdesign">
                        <TextField id="outlined-basic" label="Street Address" className='w-100' variant="outlined"  size="small"/>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="formdesign">
                        <FormControl fullWidth  size="small">
                            <InputLabel id="demo-simple-select-label">City</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" value="" label="Age">
                                <MenuItem value={10}>Ten</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="formdesign">
                        <FormControl fullWidth  size="small">
                            <InputLabel id="demo-simple-select-label">State</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" value="" label="Age">
                                <MenuItem value={10}>Ten</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="formdesign">
                        <FormControl fullWidth  size="small">
                            <InputLabel id="demo-simple-select-label">County</InputLabel>
                            <Select labelId="demo-simple-select-label" id="demo-simple-select" value="" label="Age">
                                <MenuItem value={10}>Ten</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="formdesign">
                        <TextField id="outlined-basic" label="Pincode" className='w-100' variant="outlined"  size="small"/>
                    </div>
                </div>
                <div className="col-lg-12 col-sm-12">
                        <div className="text-end">
                            <button className='btn btn-blacked outline me-2'>Cancel</button>
                            <button className='btn btn-blacked '>Update</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}
